export default __webpack_public_path__ + "static/media/Validation.e3db6360.svg";